export default __webpack_public_path__ + "static/media/bkg--enquire.c7489713.jpg";